export const resolveAmplifyConfig = (
  modules: Record<string, { default: Record<string, unknown> }>
) => Object.values(modules)[0]?.default ?? {}
